import React, { useContext } from 'react';
import "./FeedCardMediaPreview.scss";
import { apiCropImage } from '../../../../config';
import { ModalContext } from '../../ModalManager';
import FeedCardMediaPreviewVideo from '../FeedMediaPreviewVideo/FeedCardMediaPreviewVideo';

const FeedCardMediaPreview = ({media, parentWidth = 400}) => {
    const { togglePopup, openModal } = useContext(ModalContext);

    const isVideo = media.kind === 'video';
    const width = parentWidth;
    const height = parentWidth  * 1.25;

    

    const openMediaViewerModal = () => {
        openModal('ModalMediaViewer', {
            mediaId : media._id,
            mediaSlug : media.slug
        });
    };

    return (
        (
            <div className="hf-feed-card-media-preview loading-animation" >
                {isVideo ? (
                    <FeedCardMediaPreviewVideo media={media} parentWidth={parentWidth} modalIsOpen={togglePopup} handleClick={openMediaViewerModal}/>
                ) : (
                    <div className="hf-feed-card-media-preview-image-wrapper"  onClick={openMediaViewerModal}>
                        <img
                            src={apiCropImage({ url: media.previewUrl, width: '600', quality:90})}
                            style={{ minHeight: `${width}px`, maxHeight: `${height}px` }}
                            alt={ media.title}
                        />
                    </div>
                    )}
            </div>
        )
    )
}

const arePropsEqual = (prevProps, nextProps) => {
    return prevProps?.media?._id === nextProps?.media?._id &&
           prevProps.parentWidth === nextProps.parentWidth
}

export default React.memo(FeedCardMediaPreview, arePropsEqual);
